import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Head from './head';
import Chip from 'Chip';
import FeedList from './feedList';
// import ImageList from './imageList';
import StaticEdit from '../../staticEdit';
import RightNews from '../rightNews';

class Aside extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            // asideHead0,
            // asideFeed0,
            // asideHead1,
            // asideFeed1,
            // asideHead2,
            // asideFeed2,
            // asideHead3,
            // asideFeed3,
            // asideImageList,
            staticRightData,
            rightNews
        } = this.props.content;
        
        return (
            <>
                {/* <Chip id="261062" type="struct" title="行业观察" groupName="main右侧数据" content={asideHead0} >
                    <Head />
                </Chip>
                <FeedList content={asideFeed0} />

                <Chip id="261063" type="struct" title="中东投资指南" groupName="main右侧数据" content={asideHead1} >
                    <Head />
                </Chip>
                <FeedList content={asideFeed1} />

                <Chip id="261064" type="struct" title="文化旅游" groupName="main右侧数据" content={asideHead2} >
                    <Head />
                </Chip>
                <FeedList content={asideFeed2} /> */}

                {/* <Chip id="260278" type="struct" title="政务推荐" groupName="main右侧数据" content={asideHead3} >
                    <Head />
                </Chip>
                <FeedList content={asideFeed3} /> */}
{/* 
                <Chip id="260282" type="struct" title="图片列表" groupName="main右侧数据" content={asideImageList} >
                    <ImageList />
                </Chip> */}

                <Chip id="289056" type="recommend" title="右側圖文－推薦位" groupName="右侧" content={rightNews} translate="handleFoodRightNews">
                    <RightNews />
                </Chip>

                <Chip id="223301" type="static" title="右側－靜態碎片" groupName="右侧" content={staticRightData} >
                    <StaticEdit />
                </Chip>
            </>
        );
    }
}

export default Aside;
